// Lib
import React from 'react';
import { Building, Building2, User, Users, UsersRound } from 'lucide-react';

// Components
import { SelectableCard } from './SelectableCard';

type SizeType = 'solo' | '2-5' | '5-20' | '21-100' | '100+' | '';

interface SizeSelectorProps {
  size: SizeType;
  onChange: (name: string, value: string) => void;
}

const SIZE_OPTIONS: {
  value: Exclude<SizeType, ''>;
  label: string;
  Icon: typeof User;
}[] = [
  { value: 'solo', label: 'Solo', Icon: User },
  { value: '2-5', label: '2-5', Icon: Users },
  { value: '5-20', label: '5-20', Icon: UsersRound },
  { value: '21-100', label: '21-100', Icon: Building },
  { value: '100+', label: '100+', Icon: Building2 },
];

export const SizeSelector: React.FC<SizeSelectorProps> = ({
  size,
  onChange,
}) => (
  <div className="flex flex-wrap justify-center gap-2">
    {SIZE_OPTIONS.map(({ value, label, Icon }) => (
      <SelectableCard
        key={value}
        active={size === value}
        onClick={() => onChange('size', value)}
        className="w-28"
      >
        <Icon className="size-5 text-foreground" />
        <p className="text-sm text-foreground">{label}</p>
      </SelectableCard>
    ))}
  </div>
);
